import { render, staticRenderFns } from "./EditVoteBasic.vue?vue&type=template&id=392f9e16"
import script from "./EditVoteBasic.vue?vue&type=script&lang=js"
export * from "./EditVoteBasic.vue?vue&type=script&lang=js"
import style0 from "./EditVoteBasic.vue?vue&type=style&index=0&id=392f9e16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports